import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=1db72864&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=1db72864&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db72864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db72864')) {
      api.createRecord('1db72864', component.options)
    } else {
      api.reload('1db72864', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=1db72864&scoped=true", function () {
      api.rerender('1db72864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/paycools/Sidebar/Logo.vue"
export default component.exports